import Constants from '../../constants';

export default {
	getData: () => ({
		type: Constants.GET_PLUGINS_DATA,
	}),
};



// WEBPACK FOOTER //
// ./src/actions/plugins/pluginsActions.js